/**
 * `/embed` — the marketing hero's iframe entry point.
 *
 * The hero now shows the REAL, full dashboard (chrome + sidebar +
 * navigable), not a bespoke chrome-less surface — so `/embed` just
 * redirects into the app at `/performance`. Kept as a stable URL for the
 * iframe + the poster-capture job; redirects home outside a demo build so
 * the production dashboard never exposes it.
 */
import { DEMO } from '@/lib/demo';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/embed')({
  beforeLoad: () => {
    throw redirect({ to: DEMO ? '/performance' : '/' });
  },
});
